(function () {
  'use strict';

  if (window.__rohiStickyInit) return;
  window.__rohiStickyInit = true;

  var PRODUCT = null;
  var SHEET_MODE = 'cart';
  var SELECTED_OPTIONS = {};
  var QUANTITY = 1;
  var MAX_QTY_FALLBACK = 99;
  var IS_PROCESSING = false;
  var CART_QTY_BY_VARIANT = {};
  var PROCESSING_TIMEOUT = null;
  var FETCH_TIMEOUT_MS = 10000;
  var FORCE_RESET_AFTER_MS = 12000;

  function $(sel, root) {
    try {
      return (root || document).querySelector(sel);
    } catch (e) {
      return null;
    }
  }

  function $$(sel, root) {
    try {
      return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    } catch (e) {
      return [];
    }
  }

  function loadProductData() {
    var node = document.getElementById('rohiProductData');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';

    return String(str).replace(/[&<>"']/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c];
    });
  }

  function safeHide(el, hide) {
    if (!el) return;
    el.hidden = !!hide;
  }

  function clearProcessingTimeout() {
    if (PROCESSING_TIMEOUT) {
      clearTimeout(PROCESSING_TIMEOUT);
      PROCESSING_TIMEOUT = null;
    }
  }

  function setButtonLabel(btn, text) {
    if (!btn) return;
    btn.textContent = text;
  }

  function setLoadingState(btn, mode, loading) {
    if (!btn) return;

    btn.disabled = !!loading;

    if (loading) {
      setButtonLabel(btn, mode === 'buy' ? 'Processing...' : 'Adding...');
    } else {
      setButtonLabel(btn, mode === 'buy' ? 'Buy Now' : 'Add to Cart');
    }
  }

  function resetStickyButtons() {
    IS_PROCESSING = false;
    clearProcessingTimeout();

    var cartBtn = $('.rohi-sticky-bar__btn--cart');
    var buyBtn = $('.rohi-sticky-bar__btn--buy');
    var sheetCartBtn = $('#rohiSheetAddCart');
    var sheetBuyBtn = $('#rohiSheetBuyNow');

    if (cartBtn) {
      cartBtn.disabled = false;
      cartBtn.textContent = 'Add to Cart';
    }

    if (buyBtn) {
      buyBtn.disabled = false;
      buyBtn.textContent = 'Buy Now';
    }

    if (sheetCartBtn) {
      sheetCartBtn.disabled = false;
      sheetCartBtn.textContent = 'Add to Cart';
    }

    if (sheetBuyBtn) {
      sheetBuyBtn.disabled = false;
      sheetBuyBtn.textContent = 'Buy Now';
    }

    updateSheetState();
  }

  function startProcessingWatchdog() {
    clearProcessingTimeout();

    PROCESSING_TIMEOUT = setTimeout(function () {
      resetStickyButtons();
      showError('Request took too long. Please try again.');
    }, FORCE_RESET_AFTER_MS);
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var timedOut = false;

      var timer = setTimeout(function () {
        timedOut = true;
        reject(new Error('Request timed out'));
      }, timeoutMs || FETCH_TIMEOUT_MS);

      fetch(url, options)
        .then(function (response) {
          if (timedOut) return;
          clearTimeout(timer);
          resolve(response);
        })
        .catch(function (err) {
          if (timedOut) return;
          clearTimeout(timer);
          reject(err);
        });
    });
  }

  function refreshCartQuantities() {
    return fetchWithTimeout('/cart.js', {
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    }, 5000)
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        CART_QTY_BY_VARIANT = {};

        if (cart && cart.items) {
          cart.items.forEach(function (item) {
            var variantId = String(item.variant_id);
            CART_QTY_BY_VARIANT[variantId] = (CART_QTY_BY_VARIANT[variantId] || 0) + item.quantity;
          });
        }

        return cart;
      })
      .catch(function () {
        CART_QTY_BY_VARIANT = {};
        return null;
      });
  }

  function getVariantQtyInCart(variant) {
    if (!variant || !variant.id) return 0;
    return CART_QTY_BY_VARIANT[String(variant.id)] || 0;
  }

  function formatNumber(cents) {
    if (cents === null || cents === undefined) return '';
    var rupees = Math.round(Number(cents || 0) / 100);
    return rupees.toLocaleString('en-PK');
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    return 'Rs. ' + formatNumber(cents);
  }

  function formatSheetPrice(cents) {
    return (
      '<span class="rohi-sheet__currency">Rs.</span>' +
      '<span class="rohi-sheet__number">' + formatNumber(cents) + '</span>'
    );
  }

  function getCartSectionIds() {
    var ids = [];

    document.querySelectorAll('cart-items-component').forEach(function (component) {
      if (component.dataset && component.dataset.sectionId) {
        ids.push(component.dataset.sectionId);
      }
    });

    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var sectionId = el.getAttribute('data-section-id') || '';

      if (
        sectionId.indexOf('cart') !== -1 ||
        sectionId.indexOf('drawer') !== -1
      ) {
        ids.push(sectionId);
      }
    });

    return ids.filter(function (id, index) {
      return id && ids.indexOf(id) === index;
    });
  }

  function fireCartRefreshEvents(cartData, sections) {
    var detail = {
      resource: cartData || {},
      data: {
        source: 'rohi-product-page-sticky-bar',
        sections: sections || {}
      }
    };

    [
      'cart:update',
      'cart:updated',
      'cart:refresh',
      'cart:item-added',
      'cart-drawer:refresh',
      'cart-drawer:open',
      'cart:change'
    ].forEach(function (eventName) {
      try {
        document.dispatchEvent(new CustomEvent(eventName, {
          bubbles: true,
          detail: detail
        }));
      } catch (e) {}

      try {
        window.dispatchEvent(new CustomEvent(eventName, {
          bubbles: true,
          detail: detail
        }));
      } catch (e) {}
    });

    try {
      if (
        window.Shopify &&
        window.Shopify.PubSub &&
        typeof window.Shopify.PubSub.publish === 'function'
      ) {
        window.Shopify.PubSub.publish('cart:refresh');
      }
    } catch (e) {}
  }

  function openCartDrawer() {
    var drawerSelectors = [
      'cart-drawer-component',
      'cart-drawer',
      '[is="cart-drawer"]',
      'cart-drawer-dialog',
      '#CartDrawer',
      '#cart-drawer'
    ];

    for (var i = 0; i < drawerSelectors.length; i++) {
      var drawer = $(drawerSelectors[i]);

      if (drawer) {
        try {
          if (typeof drawer.open === 'function') {
            drawer.open();
            return true;
          }

          if (typeof drawer.show === 'function') {
            drawer.show();
            return true;
          }

          if (typeof drawer.showDialog === 'function') {
            drawer.showDialog();
            return true;
          }

          if (typeof drawer.showModal === 'function') {
            drawer.showModal();
            return true;
          }
        } catch (e) {}

        var dialog = $('dialog', drawer);

        if (dialog) {
          try {
            if (typeof dialog.showModal === 'function') {
              dialog.showModal();
              return true;
            }

            dialog.setAttribute('open', '');
            return true;
          } catch (e) {}
        }

        drawer.setAttribute('open', '');
        drawer.classList.add('is-open', 'active', 'animate');
        document.body.classList.add('overflow-hidden');

        return true;
      }
    }

    var triggerSelectors = [
      '[data-cart-drawer-trigger]',
      '[data-cart-toggle]',
      '.js-cart-drawer-open',
      '.header-actions__cart',
      '.header__cart',
      '[aria-controls="cart-drawer"]',
      'button[aria-controls*="cart"]',
      'button[id*="cart"]',
      'a[href$="/cart"][data-drawer]',
      'a[href*="/cart"]'
    ];

    for (var k = 0; k < triggerSelectors.length; k++) {
      var trigger = $(triggerSelectors[k]);

      if (
        trigger &&
        !trigger.closest('.rohi-sticky-bar') &&
        !trigger.closest('.rohi-sheet')
      ) {
        try {
          trigger.click();
          return true;
        } catch (e) {}
      }
    }

    return false;
  }

  function findMatchingVariant() {
    if (!PRODUCT || !PRODUCT.variants) return null;

    for (var i = 0; i < PRODUCT.variants.length; i++) {
      var v = PRODUCT.variants[i];
      var match = true;

      for (var j = 0; j < PRODUCT.options.length; j++) {
        var optName = PRODUCT.options[j];

        if (SELECTED_OPTIONS[optName] !== v.options[j]) {
          match = false;
          break;
        }
      }

      if (match) return v;
    }

    return null;
  }

  function variantAvailableForOption(optionName, optionValue) {
    if (!PRODUCT || !PRODUCT.variants) return true;

    var optIdx = PRODUCT.options.indexOf(optionName);
    if (optIdx === -1) return true;

    for (var i = 0; i < PRODUCT.variants.length; i++) {
      var v = PRODUCT.variants[i];

      if (v.options[optIdx] === optionValue && v.available) {
        return true;
      }
    }

    return false;
  }

  function getVariantInventoryLimit(variant) {
    if (!variant) return MAX_QTY_FALLBACK;

    if (
      typeof variant.inventory_quantity === 'number' &&
      variant.inventory_management &&
      variant.inventory_policy !== 'continue'
    ) {
      var inCart = getVariantQtyInCart(variant);
      var remaining = variant.inventory_quantity - inCart;

      return Math.max(0, remaining);
    }

    return MAX_QTY_FALLBACK;
  }

  function getCurrentVariantMaxQty() {
    return getVariantInventoryLimit(findMatchingVariant());
  }

  function showError(msg) {
    var box = $('#rohiSheetError');

    if (box) {
      box.textContent = msg;
      box.hidden = false;
      return;
    }

    try {
      alert(msg);
    } catch (e) {}
  }

  function clearError() {
    var box = $('#rohiSheetError');
    if (!box) return;

    box.hidden = true;
    box.textContent = '';
  }

  function renderOptions() {
    var body = $('#rohiSheetBody');
    if (!body || !PRODUCT) return;

    body.innerHTML = '';

    if (PRODUCT.has_variants && PRODUCT.options && PRODUCT.options.length) {
      PRODUCT.options.forEach(function (optName, optIdx) {
        var values = [];

        PRODUCT.variants.forEach(function (v) {
          if (values.indexOf(v.options[optIdx]) === -1) {
            values.push(v.options[optIdx]);
          }
        });

        var group = document.createElement('div');
        group.className = 'rohi-option-group';

        group.innerHTML =
          '<p class="rohi-option-group__label">' +
          escapeHtml(optName) +
          '<span class="rohi-option-group__value" data-option-display="' +
          escapeHtml(optName) +
          '">' +
          escapeHtml(SELECTED_OPTIONS[optName] || '') +
          '</span>' +
          '</p>' +
          '<div class="rohi-option-pills" data-option-name="' +
          escapeHtml(optName) +
          '"></div>';

        var pillsWrap = group.querySelector('.rohi-option-pills');

        values.forEach(function (val) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'rohi-option-pill';
          pill.textContent = val;
          pill.setAttribute('data-option-value', val);
          pill.setAttribute('aria-pressed', SELECTED_OPTIONS[optName] === val ? 'true' : 'false');

          if (!variantAvailableForOption(optName, val)) {
            pill.setAttribute('disabled', '');
          }

          pillsWrap.appendChild(pill);
        });

        body.appendChild(group);
      });
    }

    var qtyGroup = document.createElement('div');
    qtyGroup.className = 'rohi-option-group';

    qtyGroup.innerHTML =
      '<p class="rohi-option-group__label">Quantity<span class="rohi-option-group__value" id="rohiStockNote"></span></p>' +
      '<div class="rohi-qty">' +
      '<button type="button" class="rohi-qty__btn" data-qty-action="dec" aria-label="Decrease quantity">−</button>' +
      '<span class="rohi-qty__value" id="rohiQtyValue">' +
      QUANTITY +
      '</span>' +
      '<button type="button" class="rohi-qty__btn" data-qty-action="inc" aria-label="Increase quantity">+</button>' +
      '</div>';

    body.appendChild(qtyGroup);

    var errorBox = document.createElement('div');
    errorBox.className = 'rohi-sheet__error';
    errorBox.id = 'rohiSheetError';
    errorBox.hidden = true;

    body.appendChild(errorBox);
  }

  function updateSheetState() {
    var sheetBody = $('#rohiSheetBody');
    if (!sheetBody) return;

    $$('.rohi-option-pill', sheetBody).forEach(function (pill) {
      var parent = pill.parentElement;
      if (!parent) return;

      var optName = parent.getAttribute('data-option-name');
      var val = pill.getAttribute('data-option-value');

      pill.setAttribute('aria-pressed', SELECTED_OPTIONS[optName] === val ? 'true' : 'false');
    });

    $$('[data-option-display]').forEach(function (el) {
      var optName = el.getAttribute('data-option-display');
      el.textContent = SELECTED_OPTIONS[optName] || '';
    });

    var qty = $('#rohiQtyValue');
    if (qty) qty.textContent = QUANTITY;

    var variant = findMatchingVariant();
    var maxQty = getVariantInventoryLimit(variant);
    var inCart = getVariantQtyInCart(variant);

    if (QUANTITY > maxQty && maxQty > 0) {
      QUANTITY = maxQty;
      if (qty) qty.textContent = QUANTITY;
    }

    if (maxQty === 0) {
      QUANTITY = 1;
      if (qty) qty.textContent = QUANTITY;
    }

    var dec = $('[data-qty-action="dec"]');
    if (dec) dec.disabled = QUANTITY <= 1;

    var inc = $('[data-qty-action="inc"]');
    if (inc) inc.disabled = maxQty <= 0 || QUANTITY >= maxQty;

    var stockNote = $('#rohiStockNote');

    if (stockNote) {
      if (variant && maxQty === 0 && inCart > 0) {
        stockNote.textContent = 'All available stock is already in cart';
        stockNote.className = 'rohi-option-group__value rohi-option-group__value--warn';
      } else if (variant && maxQty < MAX_QTY_FALLBACK && maxQty > 0 && maxQty <= 10) {
        stockNote.textContent = inCart > 0
          ? 'Only ' + maxQty + ' left. ' + inCart + ' already in cart'
          : 'Only ' + maxQty + ' available';
        stockNote.className = 'rohi-option-group__value rohi-option-group__value--warn';
      } else {
        stockNote.textContent = '';
        stockNote.className = 'rohi-option-group__value';
      }
    }

    var sheetCartBtn = $('#rohiSheetAddCart');
    var sheetBuyBtn = $('#rohiSheetBuyNow');
    var soldOut = $('#rohiSheetSoldOut');

    if (variant) {
      var thumb = $('#rohiSheetThumb');

      if (thumb) {
        if (variant.image) {
          thumb.src = variant.image;
        } else if (PRODUCT.image) {
          thumb.src = PRODUCT.image;
        }

        thumb.alt = PRODUCT.title || '';
      }

      var priceEl = $('#rohiSheetPrice');
      if (priceEl) {
        priceEl.innerHTML = formatSheetPrice(variant.price);
      }

      var compareEl = $('#rohiSheetCompare');
      var discountEl = $('#rohiSheetDiscount');

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        }

        if (discountEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          discountEl.textContent = '-' + pct + '%';
          discountEl.hidden = false;
        }
      } else {
        safeHide(compareEl, true);
        safeHide(discountEl, true);
      }

      if (sheetCartBtn && sheetBuyBtn) {
        if (!variant.available || maxQty === 0) {
          sheetCartBtn.disabled = true;
          sheetBuyBtn.disabled = true;

          safeHide(soldOut, false);

          setButtonLabel(sheetCartBtn, maxQty === 0 && inCart > 0 ? 'Already in Cart' : 'Sold Out');
          setButtonLabel(sheetBuyBtn, maxQty === 0 && inCart > 0 ? 'Already in Cart' : 'Sold Out');
        } else {
          sheetCartBtn.disabled = IS_PROCESSING;
          sheetBuyBtn.disabled = IS_PROCESSING;

          safeHide(soldOut, true);

          setButtonLabel(sheetCartBtn, IS_PROCESSING ? 'Adding...' : 'Add to Cart');
          setButtonLabel(sheetBuyBtn, IS_PROCESSING ? 'Processing...' : 'Buy Now');
        }
      }
    } else {
      if (sheetCartBtn) {
        sheetCartBtn.disabled = true;
        setButtonLabel(sheetCartBtn, 'Select options');
      }

      if (sheetBuyBtn) {
        sheetBuyBtn.disabled = true;
        setButtonLabel(sheetBuyBtn, 'Select options');
      }
    }
  }

  function openSheet(mode) {
    SHEET_MODE = mode;
    QUANTITY = 1;
    SELECTED_OPTIONS = {};
    clearError();

    if (PRODUCT && PRODUCT.variants && PRODUCT.variants.length) {
      var defaultVariant = null;

      for (var i = 0; i < PRODUCT.variants.length; i++) {
        if (PRODUCT.variants[i].id === PRODUCT.default_variant_id) {
          defaultVariant = PRODUCT.variants[i];
          break;
        }
      }

      if (!defaultVariant) {
        defaultVariant = PRODUCT.variants[0];
      }

      PRODUCT.options.forEach(function (optName, idx) {
        SELECTED_OPTIONS[optName] = defaultVariant.options[idx];
      });
    }

    renderOptions();
    updateSheetState();

    var sheet = $('#rohiSheet');

    if (sheet) {
      sheet.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    refreshCartQuantities().then(function () {
      var variant = findMatchingVariant();
      var maxQty = getVariantInventoryLimit(variant);

      if (QUANTITY > maxQty && maxQty > 0) {
        QUANTITY = maxQty;
      }

      updateSheetState();
    });
  }

  function closeSheet() {
    var sheet = $('#rohiSheet');

    if (sheet) {
      sheet.setAttribute('aria-hidden', 'true');
    }

    document.body.style.overflow = '';
  }

  function addToCartRequest(variantId, quantity) {
    var sectionIds = getCartSectionIds();

    var payload = {
      items: [
        {
          id: Number(variantId),
          quantity: quantity || 1
        }
      ]
    };

    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
    }

    return fetchWithTimeout('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }, FETCH_TIMEOUT_MS).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) {
          var err = new Error(
            body && body.description
              ? body.description
              : body && body.message
                ? body.message
                : 'Could not add to cart. Please try again.'
          );

          err.status = response.status;
          err.body = body;
          throw err;
        }

        return body;
      });
    });
  }

  function friendlyInventoryError(err) {
    var msg = err && err.message ? err.message : '';
    var lower = msg.toLowerCase();

    var match = msg.match(/(\d+)\s+(?:are|is)?\s*available/i);

    if (match) {
      return 'Only ' + match[1] + ' available right now. Please reduce quantity.';
    }

    if (lower.indexOf('sold out') !== -1 || lower.indexOf('not available') !== -1) {
      return 'This item is sold out.';
    }

    if (lower.indexOf('timed out') !== -1) {
      return 'Network is slow. Please try again.';
    }

    if (msg) return msg;

    return 'Could not add to cart. Please try again.';
  }

  function performCart(variantId, quantity, mode, btn) {
    if (IS_PROCESSING) return;

    IS_PROCESSING = true;
    startProcessingWatchdog();

    clearError();
    setLoadingState(btn, mode, true);
    updateSheetState();

    addToCartRequest(variantId, quantity)
      .then(function (addResponse) {
        if (mode === 'buy') {
          clearProcessingTimeout();
          window.location.href = '/checkout';
          return null;
        }

        return fetchWithTimeout('/cart.js', {
          headers: {
            'Accept': 'application/json'
          },
          cache: 'no-store'
        }, 5000)
          .then(function (cartResponse) {
            return cartResponse.json();
          })
          .then(function (cartData) {
            var sections = addResponse && addResponse.sections ? addResponse.sections : {};

            CART_QTY_BY_VARIANT = {};

            if (cartData && cartData.items) {
              cartData.items.forEach(function (item) {
                var itemVariantId = String(item.variant_id);
                CART_QTY_BY_VARIANT[itemVariantId] = (CART_QTY_BY_VARIANT[itemVariantId] || 0) + item.quantity;
              });
            }

            fireCartRefreshEvents(cartData, sections);

            window.setTimeout(function () {
              fireCartRefreshEvents(cartData, sections);

              window.setTimeout(function () {
                openCartDrawer();

                closeSheet();

                refreshCartQuantities().then(function () {
                  resetStickyButtons();
                  fireCartRefreshEvents(cartData, sections);
                });
              }, 250);
            }, 150);

            return cartData;
          });
      })
      .catch(function (err) {
        resetStickyButtons();

        var sheet = $('#rohiSheet');
        var inSheet = sheet && sheet.getAttribute('aria-hidden') === 'false';
        var friendly = friendlyInventoryError(err);

        if (inSheet) {
          showError(friendly);
        } else {
          try {
            alert(friendly);
          } catch (e) {}
        }
      });
  }

  function handleStickyAction(mode) {
    if (!PRODUCT) return;
    if (IS_PROCESSING) return;

    if (!PRODUCT.has_variants) {
      var btn = $(mode === 'buy' ? '.rohi-sticky-bar__btn--buy' : '.rohi-sticky-bar__btn--cart');
      performCart(PRODUCT.default_variant_id, 1, mode, btn);
      return;
    }

    openSheet(mode);
  }

  function handleSheetAction(mode) {
    if (IS_PROCESSING) return;

    var variant = findMatchingVariant();

    if (!variant || !variant.available) return;

    var btn = mode === 'buy' ? $('#rohiSheetBuyNow') : $('#rohiSheetAddCart');

    performCart(variant.id, QUANTITY, mode, btn);
  }

  function bindGlobalEvents() {
    document.addEventListener(
      'click',
      function (e) {
        try {
          var actionBtn = e.target.closest && e.target.closest('.rohi-sticky-bar [data-action]');

          if (actionBtn) {
            e.preventDefault();
            handleStickyAction(actionBtn.getAttribute('data-action') === 'buy' ? 'buy' : 'cart');
            return;
          }

          var closeBtn = e.target.closest && e.target.closest('.rohi-sheet [data-close="true"]');

          if (closeBtn) {
            e.preventDefault();
            closeSheet();
            resetStickyButtons();
            return;
          }

          var sheetBuyNow = e.target.closest && e.target.closest('#rohiSheetBuyNow');

          if (sheetBuyNow) {
            e.preventDefault();
            handleSheetAction('buy');
            return;
          }

          var sheetAddCart = e.target.closest && e.target.closest('#rohiSheetAddCart');

          if (sheetAddCart) {
            e.preventDefault();
            handleSheetAction('cart');
            return;
          }

          var pill = e.target.closest && e.target.closest('.rohi-option-pill');

          if (pill && !pill.hasAttribute('disabled')) {
            e.preventDefault();

            var pillParent = pill.parentElement;
            var optName = pillParent ? pillParent.getAttribute('data-option-name') : null;
            var val = pill.getAttribute('data-option-value');

            if (optName) {
              SELECTED_OPTIONS[optName] = val;

              var maxQty = getCurrentVariantMaxQty();

              if (QUANTITY > maxQty && maxQty > 0) {
                QUANTITY = maxQty;
              }

              clearError();
              updateSheetState();
            }

            return;
          }

          var qtyDec = e.target.closest && e.target.closest('[data-qty-action="dec"]');

          if (qtyDec && !qtyDec.disabled) {
            e.preventDefault();

            if (QUANTITY > 1) {
              QUANTITY--;
              clearError();
              updateSheetState();
            }

            return;
          }

          var qtyInc = e.target.closest && e.target.closest('[data-qty-action="inc"]');

          if (qtyInc && !qtyInc.disabled) {
            e.preventDefault();

            var max = getCurrentVariantMaxQty();

            if (QUANTITY < max) {
              QUANTITY++;
              clearError();
              updateSheetState();
            }

            return;
          }
        } catch (err) {
          resetStickyButtons();
        }
      },
      true
    );

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var sh = $('#rohiSheet');

        if (sh && sh.getAttribute('aria-hidden') === 'false') {
          closeSheet();
          resetStickyButtons();
        }
      }
    });

    [
      'cart:updated',
      'cart:item-added',
      'cart:update',
      'cart:change',
      'cart:refresh',
      'cart-drawer:refresh',
      'cart-drawer:open'
    ].forEach(function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(function () {
          refreshCartQuantities();
          resetStickyButtons();
        }, 350);
      });
    });

    [
      'cart:close',
      'cart-drawer:close'
    ].forEach(function (evt) {
      document.addEventListener(evt, function () {
        setTimeout(function () {
          refreshCartQuantities();
          resetStickyButtons();
        }, 300);
      });
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        resetStickyButtons();
        closeSheet();
        refreshCartQuantities();
      }
    });

    window.addEventListener('focus', function () {
      setTimeout(function () {
        refreshCartQuantities();
        resetStickyButtons();
      }, 300);
    });
  }

  function init() {
    PRODUCT = loadProductData();

    if (!PRODUCT) return;

    refreshCartQuantities();
    bindGlobalEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();